<div class="lg:inner-page-wrapper relative md:py-40">
    <div class="bg-grey-100 flex flex-col-reverse md:flex-row md:bg-white">
        <div
            class="relative"
            [ngClass]="{
                'hidden md:block': removeMobileImage(),
            }"
        >
            @let headlineNoF = headline() | footnotes: true;
            <ui-m000-c010-image
                class="block h-full"
                [image]="{
                    image: image().url,
                    desktop: { width: 1000 },
                    tablet: { width: 487 },
                    mobile: { width: 767 },
                }"
                [priority]="isFirstView()"
                [alt]="image().alt || headlineNoF()"
                classList="h-full w-full aspect-[767/430] md:aspect-[686/386] object-cover"
                cover
            />

            @if (highlightBadge(); as highlightBadge) {
                <div class="bg-accent absolute top-24 right-0 flex flex-col items-end py-4 pr-16 pl-12 text-white">
                    @if (highlightBadge.value) {
                        @let highlightBadgeUnit = highlightBadge.unit | footnotes;
                        @let highlightBadgeValue = highlightBadge.value | footnotes;

                        <span class="text-14">
                            @if (highlightBadge.prefix) {
                                @let highlightBadgePrefix = highlightBadge.prefix | footnotes;
                                <span [innerHTML]="highlightBadgePrefix()"></span>
                            }
                            <span class="text-20 mr-4 font-semibold" [innerHTML]="highlightBadgeValue()"></span>
                            <span class="contents" [innerHTML]="highlightBadgeUnit()"></span>
                        </span>
                    }

                    @if (highlightBadge.kurztext) {
                        @let highlightBadgeKurztext = highlightBadge.kurztext | footnotes;
                        <span class="text-18 font-medium" [innerHTML]="highlightBadgeKurztext()"></span>
                    }
                </div>
            } @else if (priceBadge(); as priceBadge) {
                <div class="bg-accent absolute top-24 right-24 flex flex-col py-4 pr-16 pl-6 text-white">
                    <span class="text-14">{{ priceBadge.text }}</span>
                    @let priceBadgePrice = priceBadge.price | footnotes;
                    <h4 class="text-18 uppercase" [innerHTML]="priceBadgePrice()"></h4>
                </div>
            }
        </div>
        <div
            class="flex w-full flex-col justify-between px-24 pt-24 pb-40 transition-all md:max-w-[390px] md:pb-24 lg:max-w-[530px]"
        >
            <div class="flex w-full flex-col">
                @let headlineF = headline() | footnotes;
                <h3 class="text-20 md:text-34 leading-25 text-black md:leading-41" [innerHTML]="headlineF()"></h3>
                @let textF = text() | footnotes;
                <p class="text-16 leading-27 text-black md:mt-2" [innerHTML]="textF()"></p>
                <div
                    class="font-headline text-16 mt-16 flex justify-between gap-12 border-b-1 border-black leading-27 font-medium text-black md:mt-12"
                >
                    <span>{{ tableHeadline() }}</span>
                    @let tableHeadlineValueF = tableHeadlineValue() || '' | footnotes;
                    <span class="text-right" [innerHTML]="tableHeadlineValueF()"></span>
                </div>
                @for (item of tableData(); track $index) {
                    <div class="font-text text-16 mt-12 flex justify-between gap-12 leading-27 text-black md:mt-4">
                        <span>{{ item.label }}</span>
                        @let value = item.value || '' | footnotes;
                        <span class="text-right" [innerHTML]="value()"></span>
                    </div>
                }
                <div class="mt-[28px] justify-end md:mt-12 md:flex">
                    <a
                        class="button-secondary bg-white md:w-auto"
                        [hyundaiRouterLink]="link()"
                        (click)="linkClicked.emit()"
                    >
                        {{ linkText() }}
                    </a>
                </div>
            </div>
            @if (envkv(); as data) {
                @let envkvWithFootnote = data | footnotes;
                <span class="mt-24 md:justify-end" [innerHTML]="envkvWithFootnote()"></span>
            }
        </div>
    </div>
    @if (imageCaption() || nationalPricesDisclaimer()) {
        <div class="flex flex-col gap-4 px-24 pb-4 lg:w-full lg:flex-row lg:justify-between lg:px-0">
            @if (imageCaption(); as imageCaption) {
                @let imageCaptionF = imageCaption | footnotes;
                <span class="text-14 text-grey-400 leading-21" [innerHTML]="imageCaptionF()"></span>
            }

            @if (nationalPricesDisclaimer(); as nationalPricesDisclaimer) {
                <span class="text-14 text-grey-400 leading-21">
                    {{ nationalPricesDisclaimer }}
                </span>
            }
        </div>
    }
</div>
